import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from 'src/app/app.constants';
import { MerchantService, CardService } from '../../../services/index';

@Component({
  selector: 'create-customer-dialog',
  templateUrl: './create-customer-dialog.component.html',
  styleUrls: ['./create-customer-dialog.component.css'],
})
export class CreateCustomerDialogComponent implements OnInit {
  form!: FormGroup;
  nameFormControl!: FormControl;
  emailFormControl!: FormControl;
  cardFormControl!: FormControl;

  saving = false;
  error = false;
  cardsLoading = false;

  cards: any[] = [];

  constructor(
    public matDialogRef: MatDialogRef<CreateCustomerDialogComponent>,
    public fb: FormBuilder,
    private constants: Constants,
    private merchantService: MerchantService,
    private cardService: CardService,
  ) {}

  ngOnInit(): void {
    this.nameFormControl = new FormControl('', [Validators.required]);
    this.emailFormControl = new FormControl('', [Validators.email]);
    this.cardFormControl = new FormControl('', [Validators.required]);

    this.form = this.fb.group({
      name: this.nameFormControl,
      email: this.emailFormControl,
      card: this.cardFormControl,
    });

    this.getCards();
  }

  getCards(): void {
    this.cardsLoading = true;
    this.cardService
      .getCards(1000, 0)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.cards = res.docs
              .filter((card: any) => card.active)
              .map((card: any) => ({
                ...card,
                displayTitle: card.title,
                displayDescription: card.description,
              }));
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.cardsLoading = false));
  }

  createCustomer(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.saving = true;

    const data: any = {
      name: this.nameFormControl.value?.trim(),
      cardId: this.cardFormControl.value?._id,
    };

    if (this.emailFormControl.value?.trim()) {
      data.email = this.emailFormControl.value.trim();
    }

    this.merchantService
      .createCustomer(data)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.constants.snack('Customer created successfully');
            this.matDialogRef.close(true);
          }
        },
        error: (res: HttpErrorResponse) => {
          this.error = true;
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.saving = false));
  }
}
